var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modals.voteHistory)?_c('Modal',{staticClass:"vote-history",on:{"close":function($event){return _vm.toggleModal('voteHistory')}}},[_c('h3',[_vm._v("Vote history")]),_c('VoteHistoryView')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }